import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VizseekService {
  vizseekData = new BehaviorSubject<any>(null);
  vizseekData$ = this.vizseekData.asObservable();
  constructor(private http: HttpClient, private occService:OccEndpointsService) { }

  getVizseekUrl(formData){
   return this.http.post<any>(this.occService.buildUrl(`/products/searchwithimage`),formData);
    
  }
feedBack(feedBack){

  this.vizseekData$.subscribe(x=>{
    return this.http.get(this.occService.buildUrl(`products/vizseeksearchfeedback?feedBack=${feedBack}&inputFileName=${x.inputFileName}&inputFileUID=${x.inputFileUID}&firstOutputFileUID=${x.firstOutputFileUID}`)).subscribe(x=>{})
  })
      
   }

}
